
export const stepIds = {
  PROGRAMA:'programa',
  PERSONA: 'datos-personales',
  CONTACTO: 'datos-contacto',
  HOMOLOGACION: 'homologacion',
  ESTUDIOS: 'estudios',
  DATOS_ADICIONALES:'datos-adicionales',
  FACTURACION:'facturacion',
  CONFIRMACION:'confirmacion'
}

export const fieldCategories = {
  ESTUDIANTE: 'estudiante',
  ESTUDIOS_SECUNDARIOS: 'estudios_secundarios',
  ESTUDIOS_SUPERIOR: 'estudios_superior',
  ESTUDIOS_NO_TERMINADOS: 'estudios_no_terminados',
  FACTURACION: 'facturacion',
  TUTOR: 'tutor',
  SOLICITUD: 'solicitud',
};

